import { Box } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { React, useEffect, useState } from "react";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { useForm } from 'react-hook-form';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from "../../ui-elements/MyMButton";
import { MyMDragAndDrop } from "../../ui-elements/MyMDragAndDrop";
import { MyMLabel } from "../../ui-elements/MyMLabel";
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MyMTextBox } from "../../ui-elements/MyMTextBox";
import { ValidatableInputFile } from '../../ui-parts/ValidatableInputFile';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { utility } from '../../utility';
import { ValidatableTreeCheckbox } from "../../ui-parts/ValidatableTreeCheckbox";
import { ValidatablePreviewImageDropZone } from '../../ui-parts/ValidatablePreviewImageDropZone';

/**
 * FileUpload Page Component
 */
export const FileUpload = (props) => {
  const { fileId, handleModalClose } = props;
  const screenId = 'MyM602';
  const apiRequest = useMyMApi(screenId);
  const [boxFileInfo, setBoxFileInfo] = useState({
    NameDisp: "",
    NameOrgn: "",
    Description: "",
    DownloadCount: "",
    PreviewCount: "",
    BoxFile: "",
    UploadThumbnailPath: "",
    ImageFile: null
  });

  const [productTypeList, setProductTypeList] = useState([]);
  // 2024.9.16 MyMine Version2.0対応 Modify Start
  const [businessAreaSalesList, setBusinessAreaSalesList] = useState([]);
  const [businessAreaServiceList, setBusinessAreaServiceList] = useState([]);
  const [businessAreaAhsList, setBusinessAreaAhsList] = useState([]);
  const [businessAreaTrainingList, setBusinessAreaTrainingList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [productTypeChecked, setProductTypeChecked] = useState([]);
  const [businessAreaSalesChecked, setBusinessAreaSalesChecked] = useState([]);
  const [businessAreaServiceChecked, setBusinessAreaServiceChecked] = useState([]);
  const [businessAreaAhsChecked, setBusinessAreaAhsChecked] = useState([]);
  const [businessAreaTrainingChecked, setBusinessAreaTrainingChecked] = useState([]);
  // 2024.9.16 MyMine Version2.0対応 Modify End  
  const [companyChecked, setCompanyChecked] = useState([]);
  const [maxFileSize, setMaxFileSize] = useState();
  const { formState, control, handleSubmit, trigger, setValue } = useForm({
    mode: 'onSubmit',
  })
  const validationRules = useValidationRules();
  // 2024.5.8 MyMine Version1.5対応 Add Start
  const [isExtensionError, setIsExtensionError] = useState(false);
  const [isSizeError, setIsSizeError] = useState(false);
  const [conditions, setConditions] = useState(null);
  // 2024.5.8 MyMine Version1.5対応 Add End
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const [businessAreaMarketingList, setBusinessAreaMarketingList] = useState([]);
  const [businessAreaAssetList, setBusinessAreaAssetList] = useState([]);
  const [businessAreaMarketingChecked, setBusinessAreaMarketingChecked] = useState([]);
  const [businessAreaAssetChecked, setBusinessAreaAssetChecked] = useState([]);
  // 2025.7.7 MyMine Version3.0対応 Add End

  useEffect(() => {
    const callbackBoxFileListContext = async (result) => {
      // 2024.5.8 MyMine Version1.5対応 Modify Start
      const { BoxFileInfo, ...Conditions } = result;
      setConditions(Conditions);
      // 2024.5.8 MyMine Version1.5対応 Modify End
      // ファイルサイズをMBに変換し単位を追加
      result.BoxFileInfo.FileSize = result.BoxFileInfo.FileSize !== null ?
        utility.convertFileSize(result.BoxFileInfo.FileSize, constants.FileSize.MB)?.toFixed(2) + controlSettings.LabelList.lblFileSizeUnit :
        '';
      setBoxFileInfo(result.BoxFileInfo);
      setProductTypeList([...result.ProductTypeList]);
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      setBusinessAreaSalesList([...result.BusinessArea.SalesList]);
      setBusinessAreaServiceList([...result.BusinessArea.ServiceList]);
      setBusinessAreaAhsList([...result.BusinessArea.AhsList]);
      setBusinessAreaTrainingList([...result.BusinessArea.TrainingList]);
      // 2025.7.7 MyMine Version3.0対応 Add Start
      setBusinessAreaMarketingList([...result.BusinessArea.MarketingList]);
      setBusinessAreaAssetList([...result.BusinessArea.AssetList]);
      // 2025.7.7 MyMine Version3.0対応 Add End
      setCompanyList([...result.CompanyList]);
      // チェック済みのデータのNameを取得
      setProductTypeChecked([...result.ProductTypeList.filter(item => result.FileReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaSalesChecked([...result.BusinessArea.SalesList.filter(item => result.FileReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaServiceChecked([...result.BusinessArea.ServiceList.filter(item => result.FileReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaAhsChecked([...result.BusinessArea.AhsList.filter(item => result.FileReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaTrainingChecked([...result.BusinessArea.TrainingList.filter(item => result.FileReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      // 2024.9.16 MyMine Version2.0対応 Modify End
      // 2025.7.7 MyMine Version3.0対応 Add Start
      setBusinessAreaMarketingChecked([...result.BusinessArea.MarketingList.filter(item => result.FileReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaAssetChecked([...result.BusinessArea.AssetList.filter(item => result.FileReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      // 2025.7.7 MyMine Version3.0対応 Add End
      setMaxFileSize(result.MaxFileSize);
      // 編集モードで対象のデータが存在しない場合エラーにする
      if (fileId !== "" && Object.values(result.BoxFileInfo).every(value => (value === null || value === ""))) {
        handleModalClose();
        window.alert(messageList.MyM_MSG_E_0069);
      }
      if (fileId !== "") {
        // 編集モードの場合はDBに基づいてチェックを入れる
        setCompanyChecked([...result.CompanyList.filter(item => result.FileReferenceCompanyIdList.includes(item.Id)).map(item => String(item.Id))])
        // 2024.5.8 MyMine Version1.5対応 Add Start
        // 編集モードの場合はDBに基づいてサムネイルを表示する
        setBoxFileInfo({
          ...BoxFileInfo,
          // 画像ファイル名が指定されている場合、画像ファイル取得
          ...(BoxFileInfo.UploadThumbnailPath ? { ImageFile: new File([await (await fetch(`api/page/file?fileName=${BoxFileInfo.UploadThumbnailPath}`)).blob()], BoxFileInfo.UploadThumbnailPath) } : {})
        });
        // 2024.5.8 MyMine Version1.5対応 Add End
      } else {
        // 新規モードの場合は全てのチェックを入れる
        setCompanyChecked([...result.CompanyList.map(item => String(item.Id))])
      }
      setIsLoading(false);
    }


    const queryParametersPath = fileId !== "" ? `fileId=${fileId}` : "";
    apiRequest.requestJson(`api/box-file/file-upload-load?${queryParametersPath}`, 'GET', callbackBoxFileListContext)
  }, []);
  // ドラッグアンドドロップ、ファイル選択時にBoxFileを再検証
  useEffect(() => { formState.isSubmitted && trigger("BoxFile") }, [boxFileInfo["BoxFile"]])
  const { controlSettings, messageList } = useWebContext(screenId);

  // ファイルサイズをMBに変換し単位を追加
  const convertFileSizeAddUnit = (fileSize) => {
    return utility.convertFileSize(fileSize, constants.FileSize.MB).toFixed(2) + controlSettings.LabelList.lblFileSizeUnit;
  }

  const handleDrop = async (e) => {
    const item = e.dataTransfer.items[0];
    const entry = item.webkitGetAsEntry();
    if (entry.isFile) {
      const file = await new Promise((resolve) => {
        entry.file((file) => {
          resolve(file);
        });
      });
      if (file) {
        const reader = new FileReader();
        reader.onload = function (e) {
          setBoxFileInfo({
            ...boxFileInfo,
            NameOrgn: file.name,
            BoxFile: file,
            FileSize: convertFileSizeAddUnit(file.size)
          });
        };
        setValue("BoxFile", file)
        reader.readAsDataURL(file);
      }
    }
  };

  const handleSelect = (e) => {
    const file = e.target.files[0];
    // ファイル選択ダイアログでファイルを選択したときのみファイル情報を設定
    if (file) {
      setBoxFileInfo({
        ...boxFileInfo,
        NameOrgn: file.name,
        BoxFile: file,
        FileSize: convertFileSizeAddUnit(file.size),
      });
      setValue("BoxFile", file)
    }
  }

  const onError = () => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  //リクエストボディーの作成
  const makeFormData = () => {
    // 2025.7.7 MyMine Version3.0対応 Modify Start
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    const businessAreaChecked = [...businessAreaSalesChecked, ...businessAreaServiceChecked, ...businessAreaAhsChecked, ...businessAreaTrainingChecked, ...businessAreaMarketingChecked, ...businessAreaAssetChecked]
    // 2025.7.7 MyMine Version3.0対応 Modify End
    const formData = new FormData();
    for (let key of Object.keys(boxFileInfo)) {
      formData.append(key, boxFileInfo[key]);
    }
    productTypeChecked.forEach((id) => { formData.append('ProductTypeList[]', id); })
    businessAreaChecked.forEach((id) => { formData.append('BusinessAreaList[]', id); })
    companyChecked.forEach((id) => { formData.append('CompanyList[]', id); })
    // 2024.9.16 MyMine Version2.0対応 Modify End
    formData.append("FileId", fileId);
    // 2024.5.8 MyMine Version1.5対応 Add Start
    formData.append("ThumbnailFile", boxFileInfo.ImageFile);
    // 2024.5.8 MyMine Version1.5対応 Add End
    return formData;
  };


  const handleUpload = async () => {
    // 2024.5.8 MyMine Version1.5対応 Add Start
    if (isExtensionError || isSizeError) {
      window.alert(messageList.MyM_MSG_E_0003);
      return;
    }
    // 2024.5.8 MyMine Version1.5対応 Add End

    if (!window.confirm(messageList.MyM_MSG_W_0075)) return;

    setIsLoading(true);

    const callbackSuccessContext = () => {
      handleModalClose();
      window.alert(messageList.MyM_MSG_I_0016);
      setIsLoading(false);
    }

    const callbackFailedContext = () => {
      setIsLoading(false);
    }
    const formData = makeFormData();
    apiRequest.requestForm("api/box-file/upload", 'POST', callbackSuccessContext, callbackFailedContext, formData)
  }

  const handleUpdate = async () => {
    // 2024.5.8 MyMine Version1.5対応 Add Start
    if (isExtensionError || isSizeError) {
      window.alert(messageList.MyM_MSG_E_0003);
      return;
    }
    // 2024.5.8 MyMine Version1.5対応 Add End

    if (!window.confirm(messageList.MyM_MSG_W_0020)) return;

    setIsLoading(true);

    const callbackSuccessContext = () => {
      handleModalClose();
      window.alert(messageList.MyM_MSG_I_0022);
      setIsLoading(false);
    }
    const callbackFailedContext = () => {
      setIsLoading(false);
    }
    const formData = makeFormData();
    apiRequest.requestForm("api/box-file/update", 'POST', callbackSuccessContext, callbackFailedContext, formData)
  }

  const handleDelete = () => {
    if (!window.confirm(messageList.MyM_MSG_W_0017)) return;

    setIsLoading(true);
    const callbackSuccessContext = (result) => {
      handleModalClose();
      window.alert(messageList.MyM_MSG_I_0019);
      setIsLoading(false);
    }
    const callbackFailedContext = (result) => {
      setIsLoading(false);
    }
    const body = { "FileId": fileId };
    apiRequest.requestJson("api/box-file/delete", 'POST', callbackSuccessContext, callbackFailedContext, body)
  }

  let fileFieldRulles = {
    ...validationRules.fileSize(boxFileInfo.BoxFile, maxFileSize)
  }
  // 新規モードの場合に、fileフィールドにルールを追加
  if (!fileId) {
    fileFieldRulles = { ...fileFieldRulles, ...validationRules.required() }
  }

  if (companyList.length === 0 &&
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    businessAreaSalesList.length === 0 &&
    businessAreaServiceList.length === 0 &&
    businessAreaAhsList.length === 0 &&
    businessAreaTrainingList.length === 0 &&
    // 2024.9.16 MyMine Version2.0対応 Modify End
    // 2025.7.7 MyMine Version3.0対応 Add Start
    businessAreaMarketingList.length === 0 &&
    businessAreaAssetList.length === 0 &&
    // 2025.7.7 MyMine Version3.0対応 Add End
    productTypeList.length === 0)
    return (
      <MyMProgress />
    )

  return (
    <Box sx={{ padding: "5px", height: "100%", overflowY: "auto" }}>
      {isLoading && <MyMProgress />}
      <Grid container >
        <Grid item xs={8} md={8} lg={8} >
          <Grid container spacing={1} sx={{ '.MuiGrid-item': { paddingBottom: '10px' } }}>
            <Grid item xs={9.7} md={9.7} lg={4.7} >
              <MyMLabel>{controlSettings.LabelList.lblFileUpload}</MyMLabel>
              <FormControl error={formState.errors["BoxFile"] ? true : false} sx={{ width: "100%" }} >
                <MyMDragAndDrop onDrop={handleDrop}>
                  <MyMTextBox
                    error={formState.errors["BoxFile"] ? true : false}
                    helperText={formState.errors["BoxFile"]?.message}
                    width="100%"
                    inputValue="">
                  </MyMTextBox>
                </ MyMDragAndDrop>
              </FormControl>
            </Grid>
            <Grid item xs={1.3} md={1.3} lg={1.3} >
              <Box sx={{ marginTop: "24px", textAlign: "left" }} >
                <MyMDragAndDrop onDrop={handleDrop}>
                  <ValidatableInputFile
                    control={control}
                    btnLayout={{ marginLeft: "0px", width: "20px" }}
                    displayName={controlSettings.LabelList.btnRef}
                    changeFunction={handleSelect}
                    name="BoxFile"
                    rules={{ ...fileFieldRulles }}
                    formState={formState}
                    displayMessage={false}
                  />
                </MyMDragAndDrop>
              </Box>
            </Grid>
            <Grid item xs={2} md={2} lg={1.2} >
              <Box >
                <MyMLabel>{controlSettings.LabelList.lblFileSize}</MyMLabel>
                <MyMTextBox disabled={true} id="FileSize" name="FileSize" inputValue={boxFileInfo.FileSize} textAlign="right"></MyMTextBox>
              </Box>
            </Grid>
            {
              fileId ?
                // 編集モードの場合
                <>
                  <Grid item xs={5} md={5} lg={2.4} >
                    <MyMLabel align="center">{controlSettings.LabelList.lblCountDownload}</MyMLabel>
                    <Box sx={{ textAlign: "right" }}>
                      <MyMTextBox width="130px" disabled={true} inputValue={boxFileInfo.DownloadCount} textAlign="right"></MyMTextBox>
                    </Box>
                  </Grid>
                  <Grid item xs={5} md={5} lg={2.4}  >
                    <MyMLabel align="center">{controlSettings.LabelList.lblCountPreview}</MyMLabel>
                    <Box sx={{ textAlign: "right" }}>
                      <MyMTextBox width="130px" disabled={true} inputValue={boxFileInfo.PreviewCount} textAlign="right"></MyMTextBox>
                    </Box>
                  </Grid>
                </>
                :
                // 新規モードの場合
                <Grid item xs={10} md={10} lg={4.8} />
            }
            <Grid item xs={4.5} md={4.5} lg={4.5}  >
              <MyMLabel>{controlSettings.LabelList.lblDisplayFilename}</MyMLabel>
              <ValidatableTextBox
                control={control}
                name="NameDisp"
                defaultValue={boxFileInfo.NameDisp || ""}
                formState={formState}
                maxLength={300}
                rules={{
                  ...validationRules.maxLength(300),
                }}
                onBlur={e => setBoxFileInfo({ ...boxFileInfo, NameDisp: e.target.value })}
              />
            </Grid>
            <Grid item xs={7.5} md={7.5} lg={7.5} >
              <MyMLabel>{controlSettings.LabelList.lblOriginalFilename}</MyMLabel>
              <MyMTextBox width="100%" disabled={true} id="NameOrgn" name="NameOrgn" inputValue={boxFileInfo.NameOrgn || ""}></MyMTextBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12} >
              <MyMLabel>{controlSettings.LabelList.lblDescription}</MyMLabel>
              <ValidatableTextBox
                control={control}
                name="Description"
                defaultValue={boxFileInfo.Description || ""}
                formState={formState}
                maxLength={256}
                rules={{
                  ...validationRules.maxLength(256),
                }}
                onBlur={e => setBoxFileInfo({ ...boxFileInfo, Description: e.target.value })}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* 2024.5.8 MyMine Version1.5対応 Add Start */}
        <Grid item xs={4} md={4} lg={4} sx={{ padding: "10px" }}>
          <MyMLabel>{controlSettings.LabelList.lblThumbnail}</MyMLabel>
          <ValidatablePreviewImageDropZone
            height='200px'
            sx={{ width: '350px' }}
            imageFile={boxFileInfo.ImageFile}
            setImageFile={(file) => setBoxFileInfo({ ...boxFileInfo, ImageFile: file })}
            removeText={controlSettings.LabelList.btnRemove}
            isExtensionError={isExtensionError}
            setIsExtensionError={setIsExtensionError}
            isSizeError={isSizeError}
            setIsSizeError={setIsSizeError}
            messageList={messageList}
            utility={utility}
            ThumbnailFileSize={conditions.ThumbnailFileSize}
            constants={constants}
            controlSettings={controlSettings}
          />
          {/* 2024.5.8 MyMine Version1.5対応 Add End */}
        </Grid>
        <Grid item xs={12} md={12} lg={12} >
          <Box sx={{ borderBottom: "3px solid #333", marginTop: "20px" }}>
          </Box>
        </Grid>
        <Grid item xs={3} md={3} lg={3} >
          <Box sx={{ paddingTop: "20px", paddingRight: "20px" }}>
            <MyMLabel>{controlSettings.LabelList.lblCompany}</MyMLabel>
            <ValidatableTreeCheckbox
              needsCascade={true}
              controllerName="checkboxList_company"
              treeItemList={companyList}
              checkedList={companyChecked}
              setChecked={setCompanyChecked}
              control={control}
              formState={formState}
              trigger={trigger}
              clearText={controlSettings.LabelList.btnCompanyClearAll}
              height="485px"
              rules={{ ...validationRules.listRequired(companyChecked) }}
            />
          </Box>
        </Grid>
        <Grid item xs={9} md={9} lg={9} >
          <Box sx={{ borderLeft: "3px solid #333", height: "100%" }}>
            <Grid container>
              <Grid item xs={12} md={12} lg={12} >
                <Box sx={{ margin: "15px 0 10px 20px" }}>
                  <MyMLabel>{controlSettings.LabelList.lblMetadata}</MyMLabel>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6} >
                <Box sx={{ marginLeft: "20px" }}>
                  <MyMLabel>{controlSettings.LabelList.lblProductType}</MyMLabel>
                  <ValidatableTreeCheckbox
                    needsCascade={true}
                    controllerName="checkboxList_productType"
                    treeItemList={productTypeList}
                    checkedList={productTypeChecked}
                    setChecked={setProductTypeChecked}
                    control={control}
                    formState={formState}
                    trigger={trigger}
                    clearText={controlSettings.LabelList.btnProductTypeClearAll}
                    height="460px"
                  />
                </Box>
              </Grid>
              <Grid item xs={6} >
                <Box >
                  <MyMLabel>{controlSettings.LabelList.lblBusinessAreaSales}</MyMLabel>
                  <ValidatableTreeCheckbox
                    needsCascade={true}
                    controllerName="checkboxList_businessArea_sales"
                    treeItemList={businessAreaSalesList}
                    checkedList={businessAreaSalesChecked}
                    setChecked={setBusinessAreaSalesChecked}
                    control={control}
                    formState={formState}
                    trigger={trigger}
                    clearText={controlSettings.LabelList.btnBusinessAreaSalesClearAll}
                    height="460px"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {/*2024.9.16 MyMine Version2.0対応 Add Start*/}
        <Grid item xs={4} md={4} lg={4} >
          <Box sx={{ paddingTop: "20px", paddingRight: "20px" }}>
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaServiceParts}</MyMLabel>
            <ValidatableTreeCheckbox
              needsCascade={true}
              controllerName="checkboxList_company_service"
              treeItemList={businessAreaServiceList}
              checkedList={businessAreaServiceChecked}
              setChecked={setBusinessAreaServiceChecked}
              control={control}
              formState={formState}
              trigger={trigger}
              clearText={controlSettings.LabelList.btnBusinessAreaServicePartsClearAll}
              height="485px"
            />
          </Box>
        </Grid>
        <Grid item xs={4} md={4} lg={4} >
          <Box sx={{ paddingTop: "20px", paddingRight: "20px" }}>
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaAhs}</MyMLabel>
            <ValidatableTreeCheckbox
              needsCascade={true}
              controllerName="checkboxList_company_ahs"
              treeItemList={businessAreaAhsList}
              checkedList={businessAreaAhsChecked}
              setChecked={setBusinessAreaAhsChecked}
              control={control}
              formState={formState}
              trigger={trigger}
              clearText={controlSettings.LabelList.btnBusinessAreaAhsClearAll}
              height="485px"
            />
          </Box>
        </Grid>
        <Grid item xs={4} md={4} lg={4} >
          <Box sx={{ paddingTop: "20px", paddingRight: "20px" }}>
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaTraining}</MyMLabel>
            <ValidatableTreeCheckbox
              needsCascade={true}
              controllerName="checkboxList_company_training"
              treeItemList={businessAreaTrainingList}
              checkedList={businessAreaTrainingChecked}
              setChecked={setBusinessAreaTrainingChecked}
              control={control}
              formState={formState}
              trigger={trigger}
              clearText={controlSettings.LabelList.btnBusinessAreaTrainingClearAll}
              height="485px"
            />
          </Box>
        </Grid>
        {/*2024.9.16 MyMine Version2.0対応 Add End*/}
        {/*2025.7.7 MyMine Version3.0対応 Add Start*/}
        <Grid item xs={4} md={4} lg={4} >
          <Box sx={{ paddingTop: "20px", paddingRight: "20px" }}>
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaMarketing}</MyMLabel>
            <ValidatableTreeCheckbox
              needsCascade={true}
              controllerName="checkboxList_company_marketing"
              treeItemList={businessAreaMarketingList}
              checkedList={businessAreaMarketingChecked}
              setChecked={setBusinessAreaMarketingChecked}
              control={control}
              formState={formState}
              trigger={trigger}
              clearText={controlSettings.LabelList.btnBusinessAreaMarketingClearAll}
              height="485px"
            />
          </Box>
        </Grid>
        <Grid item xs={4} md={4} lg={4} >
          <Box sx={{ paddingTop: "20px", paddingRight: "20px" }}>
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaAsset}</MyMLabel>
            <ValidatableTreeCheckbox
              needsCascade={true}
              controllerName="checkboxList_company_asset"
              treeItemList={businessAreaAssetList}
              checkedList={businessAreaAssetChecked}
              setChecked={setBusinessAreaAssetChecked}
              control={control}
              formState={formState}
              trigger={trigger}
              clearText={controlSettings.LabelList.btnBusinessAreaAssetClearAll}
              height="485px"
            />
          </Box>
        </Grid>
        {/*2025.7.7 MyMine Version3.0対応 Add End*/}
      </Grid>
      <Stack direction='row' justifyContent="flex-end" alignItems="center" spacing={3} className='mt-3' sx={{ '> button': { width: '130px' }, marginTop: '8px' }}>
        {
          fileId !== "" ?
            // 編集モードの場合に表示
            <>
              <MyMButton onClick={handleDelete}>{controlSettings.LabelList.btnDelete}</MyMButton>
              <MyMButton onClick={handleSubmit(handleUpdate, onError)}>{controlSettings.LabelList.btnUpdate}</MyMButton>
              <MyMButton onClick={handleModalClose}>{controlSettings.LabelList.btnClose}</MyMButton>
            </>
            :
            // 新規モードの場合に表示
            <>
              <MyMButton onClick={handleSubmit(handleUpload, onError)}>{controlSettings.LabelList.btnUpload}</MyMButton>
              <MyMButton onClick={handleModalClose}>{controlSettings.LabelList.btnClose}</MyMButton>
            </>
        }
      </Stack>

    </Box>
  );
}